import { useMedia } from 'the-platform/useMedia';
import { BREAKPOINTS_MAX_MEDIA } from './constants.js';

function useMS() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.MS, false);
}

function useMM() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.MM, false);
}

function useTS() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.TS, false);
}

function useTM() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.TM, false);
}

function useTL() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.TL, false);
}

function useDM() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.DM, false);
}

function useDS() {
  return useMedia(BREAKPOINTS_MAX_MEDIA.DS, false);
}

export { useDM, useDS, useMM, useMS, useTL, useTM, useTS };
